"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2702],{

/***/ 42702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57026);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60581);
/* harmony import */ var src_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36717);
/* harmony import */ var src_redux_nlt_offer_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26869);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(94974);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);











const ActionBar = _ref => {
  let {
    offersCount = null
  } = _ref;
  const orders = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state => state.nlt.orders);
  const offers = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state => state.nlt.filteredOffers);
  const filterMenuIsOpen = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(state => state.nlt.filterMenuIsOpen);
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();

  const toggleFilterMenuHandler = () => dispatch((0,src_redux_nlt_offer_actions__WEBPACK_IMPORTED_MODULE_4__/* .toggleFilterMenu */ .hg)());

  const changeOrderHandler = _ref2 => {
    let {
      target: {
        value
      }
    } = _ref2;
    return dispatch((0,src_redux_nlt_offer_actions__WEBPACK_IMPORTED_MODULE_4__/* .toggleOrder */ .YQ)(value));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .SimpleGrid */ .MI, {
      columns: {
        base: 1,
        md: 4
      },
      pr: "l",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        textAlign: "left",
        display: {
          base: 'none',
          md: 'flex'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
          onClick: toggleFilterMenuHandler,
          leftIcon: filterMenuIsOpen ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
          color: "baseDark",
          fontFamily: "Montserrat-Medium",
          variant: "link",
          fontSize: "1rem",
          fontWeight: "normal",
          children: filterMenuIsOpen ? t('nltActionbarContainer:hideFilters') : t('nltActionbarContainer:showFilters')
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        textAlign: "left",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.375rem",
        pt: "2",
        pl: "3",
        children: t('nltActionbarContainer:nOffersFound', {
          count: offersCount || offers.results
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        display: {
          base: 'none',
          md: 'flex'
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        textAlign: "right",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1rem",
        display: {
          base: 'none',
          md: 'block'
        },
        children: [t('nltActionbarContainer:sortBy'), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Select */ .Ph, {
          variant: "flushed",
          display: "inline-block",
          width: "initial",
          ml: 4,
          fontFamily: "Montserrat-Regular",
          onChange: changeOrderHandler,
          children: orders.map(sort => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("option", {
            value: sort.value,
            children: sort.label || sort.name
          }, sort.value))
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Slide */ .Mi, {
      className: "offers-filters-desktop-container",
      in: filterMenuIsOpen,
      direction: "left",
      unmountOnExit: true,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(___WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ActionBar);

/***/ }),

/***/ 11745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62414);
/* harmony import */ var src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37398);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






const FilterTag = _ref => {
  let {
    item,
    groupKey,
    hasCloseButton,
    onClick
  } = _ref;
  const isHidden = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__/* .filterIsHidden */ .ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__/* .filterIsSelected */ .$W)(item, groupKey));
  const label = hasCloseButton && item.label && item.label !== '' ? item.label : item.name;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    isSelected: isSelected,
    onClick: onClick,
    hasCloseButton: hasCloseButton,
    label: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTag);

/***/ }),

/***/ 94974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NltOffers_FiltersList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/redux/nlt-offer/actions.ts
var actions = __webpack_require__(26869);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(75159);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListBox.tsx





const FiltersListBox = _ref => {
  let {
    display,
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    borderRadius: {
      base: 0,
      md: 10
    },
    bg: "baseWhite",
    p: "l",
    mt: "xxs",
    borderWidth: {
      base: 0,
      md: 1
    },
    borderColor: themes/* theme.colors.borders.grey */.r.colors.borders.grey,
    boxShadow: themes/* theme.shadows.cards */.r.shadows.cards,
    textAlign: "left",
    display: display,
    whiteSpace: {
      base: 'nowrap',
      md: 'normal'
    },
    children: children
  });
};

/* harmony default export */ var NltOffers_FiltersListBox = (FiltersListBox);
// EXTERNAL MODULE: ./src/components/NltOffers/FilterTag.tsx
var FilterTag = __webpack_require__(11745);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(27190);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListItemsWrapper.tsx




const FiltersListItemsWrapper = _ref => {
  let {
    items,
    isMobile,
    listedRows,
    children
  } = _ref;

  if (items.some(item => item.icon !== undefined) && !isMobile) {
    return listedRows ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
      minChildWidth: "100%",
      spacing: "8px",
      children: children
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
      minChildWidth: "5.625rem",
      spacing: "8px",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    overflowX: {
      base: 'scroll',
      md: null
    },
    paddingBottom: {
      base: '0.5rem',
      md: null
    },
    children: children
  });
};

/* harmony default export */ var NltOffers_FiltersListItemsWrapper = (FiltersListItemsWrapper);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterTagImage.tsx
var FilterTagImage = __webpack_require__(17679);
// EXTERNAL MODULE: ./src/redux/nlt-offer/selectors.ts
var selectors = __webpack_require__(37398);
;// CONCATENATED MODULE: ./src/components/NltOffers/FilterTagImage.tsx






const FilterTagImage_FilterTagImage = _ref => {
  let {
    item,
    groupKey,
    onClick,
    isMobile
  } = _ref;
  const isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTagImage/* default */.Z, {
    isSelected: isSelected,
    label: item.name,
    icon: item.icon,
    isMobile: isMobile,
    onClick: onClick
  });
};

/* harmony default export */ var NltOffers_FilterTagImage = (FilterTagImage_FilterTagImage);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterTagCheckbox.tsx
var FilterTagCheckbox = __webpack_require__(96406);
;// CONCATENATED MODULE: ./src/components/NltOffers/FilterTagCheckbox.tsx






const FilterTagCheckbox_FilterTagCheckbox = _ref => {
  let {
    item,
    groupKey,
    onClick
  } = _ref;
  const isHidden = (0,es/* useSelector */.v9)((0,selectors/* filterIsHidden */.ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)(item, groupKey));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTagCheckbox/* default */.Z, {
    isChecked: isSelected,
    onChange: onClick,
    label: item.name
  });
};

/* harmony default export */ var NltOffers_FilterTagCheckbox = (FilterTagCheckbox_FilterTagCheckbox);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListItemContent.tsx








const FiltersListItemContent = _ref => {
  let {
    filter
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();
  const isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });

  const toggleFilterHandler = (filter, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
    borderBottomWidth: {
      base: '0 !important'
    },
    borderTopWidth: {
      base: '0',
      md: '1px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
      paddingInlineStart: "0",
      paddingInlineEnd: "0",
      py: 4,
      _hover: {
        background: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        flex: "1",
        textAlign: "left",
        textTransform: "uppercase",
        fontFamily: "Montserrat-SemiBold",
        children: filter.label
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
      paddingInlineStart: "0",
      paddingInlineEnd: "0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemsWrapper, {
        items: filter.items,
        isMobile: isMobile,
        listedRows: filter.type === 'check',
        children: filter.type === 'icon' ? filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FilterTagImage, {
          isMobile: isMobile,
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-brands-${item.name}-${item.value}`)) : filter.type === 'check' && !isMobile ? filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FilterTagCheckbox, {
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-${item.name}-${item.value}`)) : filter.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
          item: item,
          groupKey: filter.key,
          onClick: () => toggleFilterHandler(item, filter.key)
        }, `filters-${item.name}-${item.value}`))
      })
    })]
  });
};

/* harmony default export */ var NltOffers_FiltersListItemContent = (FiltersListItemContent);
// EXTERNAL MODULE: ./src/components/common/Offers/FilterSwitch.tsx
var FilterSwitch = __webpack_require__(50178);
;// CONCATENATED MODULE: ./src/components/NltOffers/FilterSwitch.tsx






const FilterSwitch_FilterSwitch = _ref => {
  let {
    groupKey,
    title,
    label,
    onChange
  } = _ref;
  const isSelected = (0,es/* useSelector */.v9)((0,selectors/* filterIsSelected */.$W)({
    label,
    name: title,
    value: '1'
  }, groupKey));
  const {
    0: checked,
    1: setChecked
  } = (0,react.useState)(isSelected);
  (0,react.useEffect)(() => {
    return setChecked(isSelected);
  }, [isSelected]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterSwitch/* default */.Z, {
    label: label,
    title: title,
    isSelected: checked,
    onChange: onChange
  });
};

/* harmony default export */ var NltOffers_FilterSwitch = (FilterSwitch_FilterSwitch);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListItemNoChildren.tsx









const FiltersListItemNoChildren = _ref => {
  let {
    items,
    groupKey
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();

  const toggleFilterHandler = (filter, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      display: {
        base: 'block',
        md: 'none'
      },
      children: "Tag"
    }), items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
      item: item,
      groupKey: groupKey,
      onClick: () => toggleFilterHandler(item, groupKey)
    }, `filters-ref-${item.name}-${item.value}`))]
  });
};

/* harmony default export */ var NltOffers_FiltersListItemNoChildren = (FiltersListItemNoChildren);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListItem.tsx





const FiltersListItem = _ref => {
  let {
    items
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
    fontFamily: "Montserrat-Regular",
    allowToggle: true,
    children: Object.keys(items).map(idx => /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemContent, {
      filter: items[idx]
    }, idx))
  });
};

/* harmony default export */ var NltOffers_FiltersListItem = (FiltersListItem);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListGroup.tsx










const FiltersListGroup = _ref => {
  let {
    groupLabel,
    group
  } = _ref;
  const dispatch = (0,es/* useDispatch */.I0)();
  const isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
    base: true,
    md: false
  });

  const toggleFilterHandler = (value, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(value, groupKey));

  return isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: group.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
      fontFamily: "Montserrat-Regular",
      allowToggle: true,
      defaultIndex: [0],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemContent, {
          filter: group[0]
        })
      })
    }) : group.map(filter => /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
      fontFamily: "Montserrat-Regular",
      allowToggle: true,
      defaultIndex: [0],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListBox, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemContent, {
          filter: filter
        })
      })
    }, filter.label))
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListBox, {
    children: group.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: group[0].type === 'switch' ? /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FilterSwitch, {
        groupKey: group[0].key,
        title: group[0].group,
        label: group[0].label,
        onChange: _ref2 => {
          let {
            target
          } = _ref2;
          return toggleFilterHandler(target.value, group[0].key);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
          as: "h4",
          fontFamily: "Montserrat-SemiBold",
          fontSize: themes/* theme.space.m */.r.space.m,
          color: "baseNeutral.700",
          pb: 4,
          children: groupLabel
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItemNoChildren, {
          items: group[0].items,
          groupKey: group[0].key
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        as: "h4",
        fontFamily: "Montserrat-SemiBold",
        fontSize: themes/* theme.space.m */.r.space.m,
        color: "baseNeutral.700",
        pb: 4,
        children: groupLabel
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListItem, {
        items: group
      })]
    })
  });
};

/* harmony default export */ var NltOffers_FiltersListGroup = (FiltersListGroup);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersListGroups.tsx






const FiltersListGroups = () => {
  const filters = (0,es/* useSelector */.v9)(state => state.nlt.filters);
  const filtersGrouped = filters.reduce((r, a) => {
    r[a.group] = r[a.group] || [];
    r[a.group].push(a);
    return r;
  }, Object.create(null));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: Object.keys(filtersGrouped).map(filterGroup => /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListGroup, {
      groupLabel: filterGroup,
      group: filtersGrouped[filterGroup]
    }, filterGroup))
  });
};

/* harmony default export */ var NltOffers_FiltersListGroups = (FiltersListGroups);
;// CONCATENATED MODULE: ./src/components/NltOffers/FiltersList.tsx











const FiltersList = () => {
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  const dispatch = (0,es/* useDispatch */.I0)();

  const toggleFilterHandler = (filter, groupKey) => dispatch((0,actions/* toggleFilter */.cT)(filter.value, groupKey));

  const suggestedFilters = (0,es/* useSelector */.v9)(state => state.nlt.suggestedFilters);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(NltOffers_FiltersListBox, {
      display: {
        base: 'block',
        md: 'none'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
        fontFamily: "Montserrat-SemiBold",
        fontWeight: "bold",
        fontSize: themes/* theme.space.s */.r.space.s,
        color: "baseNeutral.700",
        pb: "4",
        children: t('offersListContainer:suggestedFilters')
      }), suggestedFilters.map(filterGroup => filterGroup.items.map(item => /*#__PURE__*/(0,jsx_runtime.jsx)(FilterTag/* default */.Z, {
        item: item,
        groupKey: filterGroup.key,
        onClick: () => toggleFilterHandler(item, filterGroup.key)
      }, `suggested-${item.name}-${item.value}`)))]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NltOffers_FiltersListGroups, {})]
  });
};

/* harmony default export */ var NltOffers_FiltersList = (FiltersList);

/***/ }),

/***/ 50178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68185);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const FilterSwitch = _ref => {
  let {
    title,
    label,
    isSelected,
    onChange
  } = _ref;
  const {
    0: checked,
    1: setChecked
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isSelected);
  const {
    0: isMounted,
    1: setMount
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setChecked(isSelected);
  }, [isSelected]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const onSwitchChange = evt => {
    const {
      target: {
        value
      }
    } = evt;
    setChecked(value === '1');
    onChange(evt);
    return value === '1';
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
      as: "span",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.875rem",
      color: "#656b72",
      children: label
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Switch */ .r, {
      colorScheme: "green",
      isChecked: checked,
      float: "right",
      value: "1",
      onChange: onSwitchChange
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterSwitch);

/***/ }),

/***/ 62414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3382);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const FilterTag = _ref => {
  let {
    isSelected,
    hasCloseButton,
    label,
    onClick
  } = _ref;
  const {
    0: isMounted,
    1: setMount
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const bgColor = isSelected ? src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[300] */ .r.colors.primaryGreen[300] : 'white';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    color: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[900] */ .r.colors.primaryGreen[900],
    variant: "outline",
    fontFamily: "Montserrat-Medium",
    fontWeight: "normal",
    size: "xs",
    h: "32px",
    mr: 1,
    my: 1,
    borderRadius: 4,
    bg: bgColor,
    _hover: {
      backgroundColor: bgColor
    },
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[300] */ .r.colors.primaryGreen[300],
    userSelect: "none",
    onClick: onClick,
    rightIcon: hasCloseButton ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_4__/* .CloseIcon */ .Tw, {
      boxSize: "0.7rem"
    }) : undefined,
    children: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTag);

/***/ }),

/***/ 96406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9135);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





const FilterTagCheckbox = _ref => {
  let {
    isChecked,
    label,
    onChange
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .XZ, {
    fontFamily: "Montserrat-Medium",
    color: "baseDark",
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.primaryGreen[900] */ .r.colors.primaryGreen[900],
    colorScheme: "primaryGreenCheckboxFilter",
    isChecked: isChecked,
    display: "block",
    size: "lg",
    lineHeight: "1.2",
    mb: "s",
    className: "filterCheck",
    onChange: onChange,
    children: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTagCheckbox);

/***/ }),

/***/ 17679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75159);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const FilterTagImage = _ref => {
  let {
    isSelected,
    label,
    icon,
    onClick,
    isMobile
  } = _ref;
  const borderColor = isSelected ? `${src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.green[600] */ .r.colors.green[600]}, 0 2px 8px 0 rgba(44, 190, 97, 0.13)` : src_themes__WEBPACK_IMPORTED_MODULE_3__/* .theme.colors.borders.grey */ .r.colors.borders.grey;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Badge */ .Ct, {
    suppressHydrationWarning: true,
    as: "button",
    variant: "outline",
    p: 2,
    m: 1,
    h: isMobile ? '4.563rem' : '4.688rem',
    w: isMobile ? '5.625rem' : '',
    borderRadius: 4,
    textTransform: "none",
    boxShadow: `inset 0 0 0px 1px ${borderColor}`,
    color: "baseNeutral.700",
    onClick: onClick,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
      src: icon,
      alt: "",
      width: "40",
      height: "40"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      children: label
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTagImage);

/***/ }),

/***/ 60581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const ArrowLeftIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M11.804 5c.275 0 .499.224.499.499v9.813l3.624-3.586c.183-.184.48-.184.664 0l.773.773c.184.184.184.48 0 .664l-5.781 5.735c-.184.183-.48.183-.664 0l-5.781-5.735c-.184-.183-.184-.48 0-.664l.773-.773c.184-.184.48-.184.664 0l3.623 3.587.001-9.814c0-.245.177-.449.41-.49l.09-.009z",
        transform: "translate(-48 -331) translate(45 328) matrix(-1 0 0 1 23 0) rotate(-90 11.251 12.018)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (ArrowLeftIcon);

/***/ }),

/***/ 36717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


const ArrowRightIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      fill: "#262626",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        d: "M9.603 3.75c.207 0 .374.168.374.374v7.36l2.718-2.69c.138-.137.36-.137.498 0l.58.58c.138.138.138.36 0 .498l-4.336 4.301c-.137.138-.36.138-.498 0l-4.336-4.3c-.137-.138-.137-.36 0-.499l.58-.58c.138-.137.36-.137.498 0l2.718 2.69v-7.36c0-.18.129-.331.3-.366l.075-.008z",
        transform: "translate(-1377 -1392) translate(45 1377) translate(1146 14) translate(186 1) rotate(-90 9.188 9.013)"
      })
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (ArrowRightIcon);

/***/ })

}]);